export const STATUS = {
  UN_CERTIFICATE: 'UN_CERTIFICATE',
  CERTIFIED: 'CERTIFIED',
  WAITING: 'WAITING',
  INVALID: 'INVALID',
  UPDATE: 'UPDATE'
};
export const STATUS_zh = {
  UN_CERTIFICATE: '未认证',
  CERTIFIED: '认证通过',
  WAITING: '待审核',
  INVALID: '认证失败',
  UPDATE: '个人升级企业认证'
};
export const TYPE = {
  PERSONAL: 'PERSONAL',
  ENTERPRISE: 'ENTERPRISE'
};
export const TYPE_zh = {
  PERSONAL: '个人身份认证',
  ENTERPRISE: '企业资质认证'
};
